__turbopack_context__.v({
  "className": "lato_c565f9f1-module__IHCVua__className",
  "variable": "lato_c565f9f1-module__IHCVua__variable",
});
